import React from 'react';

import { ClassicCardWeek } from 'helper/flux/classicCards';

import './index.scss';

export interface WeeklyBarsProps {
  weeks: ClassicCardWeek[];
}

const formatter = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 });

export default function WeeklyBars({ weeks }: WeeklyBarsProps) {
  const max = Math.max(...weeks.map((week) => week.value ?? 0), 0);

  return (
    <ul className="weekly-bars">
      {weeks.map((week) => (
        <li className="weekly-bars-row" key={`${week.label}-${week.semop}`}>
          <span className="weekly-bars-label">{week.label}</span>
          <span className="weekly-bars-semop">{week.semop}</span>
          <span className="weekly-bars-track">
            <span
              className="weekly-bars-fill"
              style={{ width: `${max && week.value ? Math.round((week.value / max) * 100) : 0}%` }}
            />
          </span>
          <span className="weekly-bars-value">
            {week.value === null ? '—' : formatter.format(week.value)}
          </span>
        </li>
      ))}
    </ul>
  );
}
